<!-- Breadcrumb Section -->
<div class="bg-header" *ngIf="configurationService.isTabletOrLarger$ | async">
  <div class="container-header">
    <div class="h2" routeDirective>
      <a
        [routerLink]="[appRoutesNS.Competitions.COMPETITIONS]"
        class="px-2 d-inline-block"
        ><i
          role="img"
          class="fa fa-arrow-left back-arrow"
          attr.aria-label=" {{ 'general.back' | translate }}"
        ></i
      ></a>
      {{ 'general.back' | translate }}
    </div>
  </div>
</div>
<!-- End Breadcrumb Section -->

<div class="container-lg main-container">
  <h1 class="mb-3">
    {{ (team$ | async)?.description }}
  </h1>

  <div class="row">
    <div class="col-lg-4" [hidden]="showOnlyCompetitionStanding">
      <!-- <div *ngIf="isLoading$ | async" class="spinner-border" role="status" attr.aria-label="{{ 'wcag.loading' | translate }}"></div> -->
      <!-- Card -->
      <section class="card mb-3 mb-lg-4 border rounded-3">
        <!-- Body -->
        <div class="card-body">
          <div class="card-subtitle mb-2 h4">
            {{ 'competitionModule.teamInfo' | translate }}
          </div>

          <button
            type="button"
            *ngIf="isAbleToEditTeam$ | async"
            class="btn mb-3"
            (click)="teamIsEditable = !teamIsEditable"
            [ngClass]="{
              'btn-primary': teamIsEditable,
              'btn-soft-primary': !teamIsEditable
            }"
          >
            <i
              *ngIf="!teamIsEditable"
              class="fa fa-edit"
              role="img"
              attr.aria-label="{{ 'general.edit' | translate }}"
            ></i>
            <i
              *ngIf="teamIsEditable"
              class="fa fa-check me-2"
              role="img"
              aria-hidden="true"
            ></i>
            <span *ngIf="teamIsEditable">
              {{ 'general.done' | translate }}</span
            >
          </button>

          <div class="mb-2">
            {{ 'general.status' | translate }}:

            <span
              class="badge"
              [ngClass]="{
                'bg-success': (team$ | async)?.active,
                'bg-warning': !(team$ | async)?.active
              }"
            >
              {{
                (team$ | async)?.active
                  ? ('general.active' | translate)
                  : ('general.inactive' | translate)
              }}</span
            >
          </div>
          <div *ngIf="(team$ | async)?.teamCaptainPersonId">
            <div class="card-subtitle mb-2 h4">
              {{ 'competitionModule.teamCaptain' | translate }}
            </div>

            <p>
              {{
                (memberEntities$ | async)[(team$ | async)?.teamCaptainPersonId]
                  ?.firstName
              }}
              {{
                (memberEntities$ | async)[(team$ | async)?.teamCaptainPersonId]
                  ?.middleName
              }}
              {{
                (memberEntities$ | async)[(team$ | async)?.teamCaptainPersonId]
                  ?.lastName
              }}
            </p>
          </div>

          <div
            class="py-0 mt-2"
            [hidden]="!(competitionStaffFunctions$ | async)?.length"
          >
            <div class="card-subtitle mb-2 h4">
              {{ 'competitionModule.staff' | translate }}
            </div>
            <button
              type="button"
              *ngIf="teamIsEditable"
              class="btn btn-soft-primary btn-sm"
              (click)="onClickAddStaff()"
            >
              <i
                class="fa fa-user-plus"
                role="img"
                attr.aria-label="{{ 'wcag.addStaff' | translate }}"
              ></i>
            </button>

            <ul class="list-unstyled mt-3">
              <li
                *ngFor="let staff of competitionStaff$ | async"
                class="mb-2 d-flex justify-content-between align-items-start"
              >
                <span>
                  <span *ngIf="staff?.memberId">
                    {{ (memberEntities$ | async)[staff?.memberId]?.firstName }}

                    {{ (memberEntities$ | async)[staff?.memberId]?.middleName }}
                    {{ (memberEntities$ | async)[staff?.memberId]?.lastName }}
                  </span>

                  <span *ngIf="!staff?.memberId"> {{ staff?.email }} </span>
                  <small *ngIf="staff?.competitionStaffFunctionId"
                    >({{
                      (competitionStaffFunctionEntities$ | async)[
                        staff?.competitionStaffFunctionId
                      ]?.staffFunction
                    }})</small
                  >
                </span>

                <button
                  type="button"
                  *ngIf="teamIsEditable && (competitionStaff$ | async)?.length"
                  (click)="onClickRemoveStaff(staff.id)"
                  class="btn btn-soft-primary btn-sm"
                >
                  <i
                    class="fa fa-user-minus"
                    role="img"
                    attr.aria-label="{{ 'wcag.removeStaff' | translate }}"
                  ></i>
                </button>
              </li>
            </ul>
          </div>

          <div class="card-subtitle mb-2 h4">
            {{ 'competitionModule.players' | translate }}
          </div>
          <button
            type="button"
            *ngIf="teamIsEditable"
            class="btn btn-soft-primary btn-sm"
            (click)="onClickAddPlayer()"
          >
            <i
              class="fa fa-user-plus"
              role="img"
              attr.aria-label="{{ 'wcag.addPlayer' | translate }}"
            ></i>
          </button>
          <ul class="list-unstyled mt-3">
            <li
              *ngFor="let player of competitionPlayers$ | async"
              class="d-flex mb-2 justify-content-between align-items-start"
            >
              <span>
                <span class="badge bg-soft-primary me-2">
                  {{ [player?.number] }}
                </span>
                <span *ngIf="player?.memberId">
                  {{ (memberEntities$ | async)[player?.memberId]?.firstName }}
                  {{ (memberEntities$ | async)[player?.memberId]?.middleName }}
                  {{ (memberEntities$ | async)[player?.memberId]?.lastName }}
                </span>

                <span *ngIf="!player?.memberId"> {{ player?.email }} </span>
              </span>

              <button
                type="button"
                *ngIf="teamIsEditable && (competitionPlayers$ | async)?.length"
                (click)="onClickRemovePlayer(player.id)"
                class="btn btn-soft-primary btn-sm"
              >
                <i
                  class="fa fa-user-minus"
                  role="img"
                  attr.aria-label="{{ 'wcag.removePlayer' | translate }}"
                ></i>
              </button>
            </li>
          </ul>
        </div>
        <!-- End Body -->
      </section>
      <!-- End Card -->
    </div>

    <div class="col-lg-8">
      <!-- Card -->
      <section class="card mb-3 mb-lg-4 border rounded-3">
        <!-- Body -->
        <div class="card-body card-body-height">
          <!-- Nav -->
          <nav
            attr.aria-label="{{ 'wcag.competitionMenu' | translate }}"
            role="tablist"
          >
            <ul class="nav nav-tabs align-items-center ps-2">
              <li class="nav-item" [hidden]="showOnlyCompetitionStanding">
                <a
                  class="nav-link"
                  (click)="selectedTab = 'matches'"
                  (keyup.enter)="selectedTab = 'matches'"
                  [ngClass]="{
                    active: selectedTab == 'matches'
                  }"
                  href="javascript:;"
                  role="tab"
                  [attr.aria-selected]="
                    selectedTab == 'matches' ? 'true' : 'false'
                  "
                >
                  {{ 'competitionModule.matches' | translate }}
                </a>
              </li>
              <li class="nav-item" [hidden]="showOnlyCompetitionStanding">
                <a
                  class="nav-link"
                  (click)="selectedTab = 'referee'"
                  (keyup.enter)="selectedTab = 'referee'"
                  [ngClass]="{
                    active: selectedTab == 'referee'
                  }"
                  href="javascript:;"
                  role="tab"
                  [attr.aria-selected]="
                    selectedTab == 'referee' ? 'true' : 'false'
                  "
                >
                  {{ 'competitionModule.referee' | translate }}
                </a>
              </li>

              <li class="nav-item" [hidden]="showOnlyCompetitionStanding">
                <a
                  class="nav-link"
                  (click)="selectedTab = 'results'"
                  (keyup.enter)="selectedTab = 'results'"
                  [ngClass]="{ active: selectedTab == 'results' }"
                  href="javascript:;"
                  role="tab"
                  [attr.aria-selected]="
                    selectedTab == 'results' ? 'true' : 'false'
                  "
                >
                  {{ 'competitionModule.results' | translate }}
                </a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  (click)="selectedTab = 'tables'"
                  (keyup.enter)="selectedTab = 'tables'"
                  [ngClass]="{
                    active: selectedTab == 'tables'
                  }"
                  href="javascript:;"
                  role="tab"
                  [attr.aria-selected]="
                    selectedTab == 'tables' ? 'true' : 'false'
                  "
                >
                  {{ 'competitionModule.tables' | translate }}
                </a>
              </li>

              <li class="nav-item" [hidden]="showOnlyCompetitionStanding">
                <a
                  class="nav-link"
                  (click)="selectedTab = 'topScorer'"
                  (keyup.enter)="selectedTab = 'topScorer'"
                  [ngClass]="{
                    active: selectedTab == 'topScorer'
                  }"
                  href="javascript:;"
                  role="tab"
                  [attr.aria-selected]="
                    selectedTab == 'topScorer' ? 'true' : 'false'
                  "
                >
                  {{ 'competitionModule.topScorer' | translate }}
                </a>
              </li>
            </ul>
          </nav>

          <!-- End Nav -->
          <matches-tab *ngIf="selectedTab == 'matches'"></matches-tab>
          <referee-tab *ngIf="selectedTab == 'referee'"></referee-tab>
          <results-tab *ngIf="selectedTab == 'results'"></results-tab>
          <tables-tab *ngIf="selectedTab == 'tables'"></tables-tab>
          <top-scorer-tab
            *ngIf="selectedTab == 'topScorer'"
            [competitionId]="(team$ | async)?.competitionId"
          >
          </top-scorer-tab>
        </div>
        <!-- End Body -->
      </section>
    </div>
  </div>

  <!-- End Row -->
</div>
